import React, {useState, useEffect, useCallback} from 'react';
import { useNavigate } from 'react-router-dom';
import CryptoJS from "crypto-js";
import { jwtDecode } from 'jwt-decode';
import questionsYN from "../../../JSONS/ev-survey-C.json"
import SleepApneaCalc from '../CalculatorCodes/SleepApneaCode';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import restrictions from "../../../JSONS/calculator_res.json"

const SleepCalculator = () => {

    const Navigate = useNavigate();
    const MySwal = withReactContent(Swal)

    const Token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : null;
    const decodedToken = Token ? jwtDecode(CryptoJS.AES.decrypt(Token, process.env.REACT_APP_TOKEN_ENC,{ mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).toString(CryptoJS.enc.Utf8)) : null;
    const opening = decodedToken && decodedToken.health_report === false && window.localStorage.getItem("HabitsCalculated") ? JSON.parse(window.localStorage.getItem("HabitsCalculated")) : decodedToken ? decodedToken.health_report : false

    const [PageStart, setPageStart] = useState(decodedToken ? true : false)
    const [TaskDone, setTaskDone] = useState(false)
    const [SurveyPage, setSurveyPage] = useState(0);
    const [PagewidthCorrection, setPagewidthCorrection] = useState(window.innerWidth > 450 ? false : true);

    // Page 1 variables
    const [Height,setHeight] = useState("")
    const [PastHeight,setPastHeight] = useState(false)
    const [Weight,setWeight] = useState("")
    const [PastWeight,setPastWeight] = useState(false)
    const [Neck,setNeck] = useState("")
    const [PastNeck,setPastNeck] = useState(false)
    const [Sistolic,setSistolic] = useState("")
    const [PastSistolic,setPastSistolic] = useState(false)
    const [validation, setvalidation] = useState({
          "Weight": "valid",
          "Height": "valid",
          "Neck": "valid",
          "Sistolic": "valid"
    });

    // Page 2 variables
    const [YNAnswers, setYNAnswers] = useState([-1,-1,-1])
    const [YNAnswersCat, setYNAnswersCat] = useState(["","",""])
    const [YNIncomplete, setYNIncomplete] = useState(false);
    const [YNPoints, setYNPoints] = useState([0,0,0]);

    // Submit variables
    const [Risk, setRisk] = useState(false)
    const [Sendoff, setSendoff] = useState(false)

    const Gender = decodedToken ? parseInt(decodedToken.gender) : null

    const DoB = decodedToken ? new Date(decodedToken.born) : null;
    const DoBMonth = DoB ? DoB.getMonth() + 1 : 0
    const DoBDay = DoB ? DoB.getDate() : 0

    function AgeCalc() {
        const currentDate = new Date();
    
        const age = currentDate.getFullYear() - DoB.getFullYear();
        const currentMonth = currentDate.getMonth()+1;
        const currentDay = currentDate.getDate();
    
        if (age > 15) {
          if (currentMonth > DoBMonth || (currentMonth === DoBMonth && currentDay >= DoBDay)) {
            return age;
          } else {
            return age-1;
          }
        } else if (age === 15) {
    
          if (currentMonth > DoBMonth || (currentMonth === DoBMonth && currentDay >= DoBDay)) {
            return age;
          }
        }
    
        return false;
    }
    const Age = DoB ? AgeCalc() : 0

    useEffect(() => {
        if(!opening || Age > restrictions["sleep_apnea"].max_age) {
        window.scrollTo(0, 0);
        Navigate("/perfil-de-usuario/calculadora-de-salud")
        }
    }, [opening, Navigate, Age]);

    function getIMC(height = Height, weight = Weight) {
        let imc = parseInt(weight)/(parseInt(height)/100)**2
        let cats = ["Bajo", "Saludable", "Sobrepeso", "Obesidad I", "Obesidad II", "Obesidad III"]
        let which = 0
        let ideal = [0,0]
        if(imc < 18.5) {
            which = 0
        } else if(imc < 25 & imc >= 18.5) {
            which = 1
        } else if(imc < 30 & imc >= 25) {
            which = 2
        } else if(imc < 35 & imc >= 30) {
            which = 3
        } else if(imc < 40 & imc >= 35) {
            which = 4
        } else {
            which = 5
        }
        ideal[0] = Math.round(((height/100)**2) * 18.5)
        ideal[1] = Math.round(((height/100)**2) * 25)
        return [imc, cats[which], which, ideal]
    }

    function HandleSubmitFirstPart() {
        let isWeightValid = Weight.trim() === "" ? "invalid" : "valid";
        let isHeightValid = Height.trim() === "" ? "invalid" : "valid";
        let isNeckValid = Neck.trim() === "" ? "invalid" : "valid";
        let isSistolicValid = Sistolic.trim() === "" ? "invalid" : Sistolic < 40 ? "invalid" : Sistolic > 370 ? "invalid" : "valid";
    
        if(Weight < 2 || Weight > 650) {
            isWeightValid = "invalid"
        }
        if(Height < 54 || Height > 272) {
            isHeightValid = "invalid"
        }
        if(Neck < 30 || Neck > 60) {
            isNeckValid = "invalid"
        }
    
        setvalidation({
            "Weight": isWeightValid,
            "Height": isHeightValid,
            "Neck": isNeckValid,
            "Sistolic": isSistolicValid,
        });
    
        if (isWeightValid === "valid" && isHeightValid === "valid" && isNeckValid === "valid" && isSistolicValid === "valid"){
            document.body.scrollTop = 0; 
            document.documentElement.scrollTop = 0;
            setSurveyPage(1)
        }
    }

    function handleYNs(number, question, ans) {
        let points = YNPoints
        let allanswers = YNAnswers
        let saveanswers = YNAnswersCat
        let tmp1 = document.getElementById(question+'Y')
        let tmp2 = document.getElementById(question+'N')
    
        if(ans === 'Y' && YNAnswersCat[question] !== "SÍ") {
            if(tmp2.className.includes("DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile")) {
              points[number] -= questionsYN[question].answers[1].points
            }
            allanswers[number] = questionsYN[question].answers[0].points
            saveanswers[number] = "SI"
            points[number] += questionsYN[question].answers[0].points
        } else if(ans === 'N' && YNAnswersCat[question] !== "NO"){
            if(tmp1.className.includes("DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile")) {
              points[number] -= questionsYN[question].answers[0].points
            }
            allanswers[number] = questionsYN[question].answers[1].points
            saveanswers[number] = "NO"
            points[number] += questionsYN[question].answers[1].points
        }
    
        //console.log(tmp1.className,tmp2.className)
        setYNAnswers([...allanswers])
        setYNAnswersCat([...saveanswers])
        setYNPoints([...points])
    }
    
    function YNVerify() {
        let CurrentQs = YNAnswers
        if(CurrentQs.includes(-1)) {
            if(YNIncomplete) return
            setYNIncomplete(true)
        } else {
            let gender = Gender === 1 ? "M" : "F"
            let imc = getIMC()
            setRisk(SleepApneaCalc(gender,Age,imc[0],Sistolic,Neck,YNPoints))
            setSendoff(true)
            setYNIncomplete(false)
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
        }
    }

    const requestGetPatient = useCallback(async() => {

        MySwal.fire({
            position: "center",
            html: 
            <div className="FullAlertWidth1">
              <div className="FullAlertUpTitle">Cargando información de perfil...</div>
              <img alt="" className="FullAlertImageGif" src="https://static.yomecontrolo.cl/public/icons/ymc-loading.gif"/>
            </div>,
            color: "#340066",
            customClass: 'swal-wide',
            showConfirmButton: false,
            width: "100%",
        })

        let parameters2 = {
            rut: decodedToken.rut,
            within: [51,52,53,57]
        }
    
        let requestOptions2 = {
            method: 'POST',
            redirect: 'follow',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(parameters2)
        };
    
        try{
        let hasParams = true
        let resp2 = await fetch("https://ymc-graph-api.azurewebsites.net/getuserparams", requestOptions2)
        if (resp2.status !== 200){
            if(resp2.status !== 500) {
                MySwal.fire({
                    icon: "error",
                    title: "Ocurrió un error al subir los datos",
                    text: "Por favor inténtelo más tarde",
                    showConfirmButton: true
                });
                return false;
            } else {
                hasParams = false
            }
        }
        let data2 = await resp2.json();
        
        if(hasParams) {
            if(data2.params["51"]) {
                setWeight(data2.params["51"][1])
                setPastWeight(true)
            }
            if(data2.params["52"]) {
                setHeight(data2.params["52"][1])
                setPastHeight(true)
            }
            if(data2.params["53"]) {
                setSistolic(data2.params["53"][1])
                setPastSistolic(true)
            }
            if(data2.params["57"]) {
                setNeck(data2.params["57"][1])
                setPastNeck(true)
            }
        }

        MySwal.close();
        setTaskDone(true);
        }
        catch(error){
            MySwal.fire({
                icon: "error",
                title: "Ocurrió un error procesando la búsqueda",
                text: "Por favor inténtelo más tarde",
                showConfirmButton: true
            });
            return false;
        }
    },[MySwal,decodedToken]);

    useEffect(() => {
        if(PageStart && decodedToken) {
            requestGetPatient()
            setPageStart(false)
        }
    }, [PageStart, requestGetPatient, decodedToken])

    const uploadSleep = useCallback( async() => {

        MySwal.fire({
            position: "center",
            html: 
            <div className="FullAlertWidth1">
              <div className="FullAlertUpTitle">Calculando...</div>
              <img alt="" className="FullAlertImageGif" src="https://static.yomecontrolo.cl/public/icons/ymc-loading.gif"/>
            </div>,
            color: "#340066",
            customClass: 'swal-wide',
            showConfirmButton: false,
            width: "100%",
        })
    
        var params = {
            rut: decodedToken.rut,
            gender: Gender,
            age: Age,
            height: Height,
            weight: Weight,
            neck: Neck,
            sistolic: Sistolic,
            YN: YNPoints,
            sleep_points: Risk["points"],
            sleep_risk: Risk["risk"],
        };
    
        let finalParamids = [
            !PastWeight ? 51 : false,
            !PastHeight ? 52 : false,
            !PastSistolic ? 53 : false,
            !PastNeck ? 57 : false,
        ].filter(med => med !== false);
        let finalResults = [
            !PastWeight ? Weight : false,
            !PastHeight ? Height : false,
            !PastSistolic ? Sistolic : false,
            !PastNeck ? Neck : false,
        ].filter(med => med !== false);
    
        let Dated = new Date()
    
        let params2 = {
            rut: decodedToken.rut,
            sex: Gender === 1 ? "M" : "F",
            ans: finalResults,
            ids: finalParamids,
            sleepApnea: Risk["risk"],
            date: Dated
        }
        
        let requestOptions = {
            method: 'POST',
            redirect: 'follow',
            headers: {
            "Content-Type": "application/json",
            },
            body: JSON.stringify(params)
        };
    
        let requestOptions2 = {
            method: 'POST',
            redirect: 'follow',
            headers: {
            "Content-Type": "application/json",
            },
            body: JSON.stringify(params2)
        };
    
        try{
    
            const resp = await fetch("https://ymc-doc-api.azurewebsites.net/usersleep", requestOptions)
            if (resp.status !== 200){
                MySwal.fire({
                icon: "error",
                title: "Ocurrió un error al subir los datos",
                text: "Por favor inténtelo más tarde",
                showConfirmButton: true
                });
                return false;
            }
    
            const resp2 = await fetch("https://ymc-graph-api.azurewebsites.net/addnewparamresults", requestOptions2)
            if (resp2.status !== 200){
                MySwal.fire({
                icon: "error",
                title: "Ocurrió un error al subir los datos",
                text: "Por favor inténtelo más tarde",
                showConfirmButton: true
                });
                return false;
            }

            setSurveyPage(2)
            document.body.scrollTop = 0; 
            document.documentElement.scrollTop = 0;
            MySwal.close();
        }
        catch(error){
            //console.log("there has been an error login in")
            MySwal.fire({
                icon: "error",
                title: "Ocurrió un error al subir los datos",
                text: "Por favor inténtelo más tarde",
                showConfirmButton: true
            });
            return false
        }
    },[Age,Gender,Height,MySwal,PastHeight,PastWeight,Risk,Weight,decodedToken,YNPoints,Neck,PastNeck,Sistolic,PastSistolic])

    useEffect(() => {
        if(Sendoff) {
            uploadSleep()
            setSendoff(false)
        }
    }, [Sendoff, uploadSleep]);

    function toggleAdditional(id) {
        let tmp = document.getElementById(id)
        if(tmp.className.includes("UserWelcomeBlockPage1SpecificsHidden")) {
          tmp.className = tmp.className.replace(" UserWelcomeBlockPage1SpecificsHidden", "");
        } else {
          tmp.className += " UserWelcomeBlockPage1SpecificsHidden"
        }
    }

    const handleChange = (value, setValue) => {
        const result = value.replace(/\D/g, '');
        setValue(result.slice(0, 3));
    };

    const HandleFaces = useCallback(() => {
        if(window.innerWidth > 450 && PagewidthCorrection) {
            setPagewidthCorrection(false)
        } 
        if(window.innerWidth <= 450 && !PagewidthCorrection) {
            setPagewidthCorrection(true)
        } 
    },[PagewidthCorrection])

    useEffect(() => {
        window.addEventListener("resize", HandleFaces);
        return () => window.removeEventListener("resize", HandleFaces);
    }, [HandleFaces]);

    function toggleDescription(type,num="") {
        let tmp = document.getElementById("More"+num)
        let tmp2 = document.getElementById("Less"+num)
        if(type === "Less") {
            tmp.className += " HeartAgeCalculatorResultsRightSideWhatIfConsequenceHidden"
            tmp2.className = tmp2.className.replace(" HeartAgeCalculatorResultsRightSideWhatIfConsequenceHidden", "");
        } else {
            tmp.className = tmp.className.replace(" HeartAgeCalculatorResultsRightSideWhatIfConsequenceHidden", "");
            tmp2.className += " HeartAgeCalculatorResultsRightSideWhatIfConsequenceHidden"
        }
    }

    return (
        <div className='UserProfileFull'>
            <div className='UserProfileInnerDiv'>
                <div className='UserProfileInnerDivCalculatorWhiteBlock2'>
                    {TaskDone ?
                    <>
                    {SurveyPage < 2 ?
                    null
                    :
                    <div className="HeartAgeCalculatorResultsTitleDiv UserProfileHeartAgeCalculatorWhiteBlockTitleDiv" style={{backgroundColor:"#CCCCFF"}}>
                        <div className="HeartAgeCalculatorRightSideTitleFlex">
                        <img alt="" className="HeartAgeCalculatorRightSideTitleIcon" src="https://static.yomecontrolo.cl/public/icons/HealthCalculatorPurpleLogo.png"/>
                        <div className="HeartAgeCalculatorRightSideTitleInnerDiv">
                            <div className="HeartAgeCalculatorRightSideUpTitle">Calculadora de Salud</div>
                            <div className="HeartAgeCalculatorRightSideTitle">Resultados</div>
                            <div className="HeartAgeCalculatorRightSideUpTitle">Riesgo de Apnea del Sueño</div>
                        </div>
                        </div>
                        <img alt="" className="HeartAgeCalculatorResultsTitleYMCLogo" src="https://static.yomecontrolo.cl/public/icons/YMC_Logo_NoText.png"/>
                    </div>
}
                    {SurveyPage === 0 ?
                    <>
                    <div className='UserWelcomeBlockPageWideFlex'>
                        <div className='UserWelcomeBlockPageWideSideL'>
                            <div className='UserWelcomeBlockPage1TitleFlex'>
                                <div className='UserWelcomeBlockPage1Title'>Riesgo de Apnea del Sueño&ensp;</div>
                                <div className="UserWelcomeBlockPage1MoreInfo" onClick={() => toggleAdditional("Added1")}>?</div>
                            </div>
                            <div className="UserWelcomeBlockPage1Specifics UserWelcomeBlockPage1SpecificsHidden" id="Added1">Para vivir bien hay que dormir bien, roncar no es normal.
                            <br/>La apnea obstructiva del sueño es un trastorno en el que la respiración se interrumpe repetidamente durante el sueño, lo que puede afectar tu salud, energía diaria y calidad de vida. Si roncas, te despiertas cansado o sientes somnolencia durante el día, podrías estar en riesgo. Evaluar y gestionar este riesgo es clave para prevenir complicaciones y mejorar tu bienestar. Utiliza nuestra herramienta para identificar tu situación y tomar el control de tu salud.</div>
                            <img alt="" className='UserWelcomeBlockPage1TitleFoodImage' src="https://static.yomecontrolo.cl/public/img/calculator/SleepApneaSurveyImage.png" />
                            <div className='UserProfileInnerDivCalculatorWhiteBlockCompletionText'><span className='UserProfileInnerDivCalculatorWhiteBlockCompletionBigNumber'>1</span> de 2</div>
                            <div className='UserWelcomeIntroPageCounterLineStart'>
                                <div className='UserWelcomeIntroPageCounterLinePurple'></div>
                                <div className='UserWelcomeIntroPageCounterLine'></div>
                            </div>
                        </div>
                        <div className='UserWelcomeBlockPageWideSideR'>
                            <div className="UserProfileHeartAgeCalculatorWhiteBlockTitle">Evalúa el riesgo  apnea obstructiva del sueño respondiendo las siguientes preguntas</div>
                            <div className="UserWelcomeBlockYNQuestion">Antecedentes precompletados</div>
                            <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompleted">
                                • Edad: {Age}<br/>
                                • Sexo al Nacer: {Gender === 1 ? "Hombre" : "Mujer"}<br/>
                                {PastHeight ?
                                <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlex">
                                    <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexLeft">• Estatura: {Height} cm</div>
                                    <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexRight" onClick={() => setPastHeight(false)}>Editar
                                    <img alt="" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleWritingIcon.svg" />
                                    </div>
                                </div>
                                : null}
                                {PastWeight ? 
                                <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlex">
                                    <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexLeft">• Peso: {Weight} Kg</div>
                                    <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexRight" onClick={() => setPastWeight(false)}>Editar
                                    <img alt="" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleWritingIcon.svg" />
                                    </div>
                                </div>
                                : null}
                                {PastNeck ? 
                                <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlex">
                                    <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexLeft">• Circumferencia de cuello: {Neck} cm</div>
                                    <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexRight" onClick={() => setPastNeck(false)}>Editar
                                    <img alt="" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleWritingIcon.svg" />
                                    </div>
                                </div>
                                : null}
                                {PastSistolic ? 
                                <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlex">
                                    <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexLeft">• Presión Sistólica: {Sistolic} mmHg</div>
                                    <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexRight" onClick={() => setPastSistolic(false)}>Editar
                                    <img alt="" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleWritingIcon.svg" />
                                    </div>
                                </div>
                                : null}
                            </div>
                            <div className="UserProfileHeartAgeCalculatorWhiteBlockQuestionFlex">
                                { PastWeight ?
                                null
                                :
                                <div className="UserProfileHeartAgeCalculatorWhiteBlockQuestion">
                                    <div className="UserWelcomeBlockYNQuestion UserWelcomeBlockYNQuestionFullSize" style={{color: validation["Weight"] === "invalid" ? "red" : validation["Weight"] === "valid" ? "#8BC53F" : null}}>Ingresa tu peso </div>
                                    <div className="HeartAgeCalculatorRightSideSurveyQ1MeasureFlex">
                                    <input
                                        value={Weight}
                                        className="SignInInnerBoxInputTile"
                                        style={{ borderBottom: validation["Weight"] === "invalid" ? "red solid 1px" : validation["Weight"] === "valid" ? "#8BC53F solid 1px" : Weight.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Weight"] === "invalid" ? "#FFFAEA" : validation["Weight"] === "valid" || Weight.length === 0 ? "#FBFFFF" : "#F2F2FF" }}
                                        id="YMCWeight"
                                        onChange={(e) => handleChange(e.target.value,setWeight)}/>
                                    <div className="DiabetesRiskCalculatorRightSideSurveyQ4InputMeasure">kg</div>
                                    </div>
                                    {validation["Weight"] === "invalid" ?
                                        <div className='WeightAlert' style={{ color: "red", fontWeight: "500" }}> Input inválido o fuera de rango </div>
                                    : null }
                                </div>
                }
                                { PastHeight ?
                                    null
                                :
                                <div className="UserProfileHeartAgeCalculatorWhiteBlockQuestion">
                                    <div className="UserWelcomeBlockYNQuestion UserWelcomeBlockYNQuestionFullSize" style={{color: validation["Height"] === "invalid" ? "red" : validation["Height"] === "valid" ? "#8BC53F" : null}}>Ingresa tu altura </div>
                                    <div className="HeartAgeCalculatorRightSideSurveyQ1MeasureFlex">
                                    <input
                                        value={Height}
                                        className="SignInInnerBoxInputTile"
                                        style={{ borderBottom: validation["Height"] === "invalid" ? "red solid 1px" : validation["Height"] === "valid" ? "#8BC53F solid 1px" : Height.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Height"] === "invalid" ? "#FFFAEA" : validation["Height"] === "valid" || Height.length === 0 ? "#FBFFFF" : "#F2F2FF" }}
                                        id="YMCHeight"
                                        onChange={(e) => handleChange(e.target.value,setHeight)}/>
                                    <div className="DiabetesRiskCalculatorRightSideSurveyQ4InputMeasure">cm</div>
                                    </div>
                                    {validation["Height"] === "invalid" ?
                                        <div className='HeightAlert' style={{ color: "red", fontWeight: "500" }}> Input inválido o fuera de rango </div>
                                    : null }
                                </div>
                }
                                { PastNeck ?
                                    null
                                :
                                <div className="UserProfileHeartAgeCalculatorWhiteBlockQuestion">
                                    <div className="UserWelcomeBlockYNQuestion UserWelcomeBlockYNQuestionFullSize" style={{color: validation["Neck"] === "invalid" ? "red" : validation["Neck"] === "valid" ? "#8BC53F" : null}}>Ingresa tu circumferencia de cuello</div>
                                    <div className="HeartAgeCalculatorRightSideSurveyQ1MeasureFlex">
                                    <input
                                        value={Neck}
                                        className="SignInInnerBoxInputTile"
                                        style={{ borderBottom: validation["Neck"] === "invalid" ? "red solid 1px" : validation["Neck"] === "valid" ? "#8BC53F solid 1px" : Neck.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Neck"] === "invalid" ? "#FFFAEA" : validation["Neck"] === "valid" || Neck.length === 0 ? "#FBFFFF" :"#F2F2FF" }}
                                        id="YMCNeck"
                                        onChange={(e) => handleChange(e.target.value,setNeck)}/>
                                    <div className="DiabetesRiskCalculatorRightSideSurveyQ4InputMeasure">cm</div>
                                    </div>
                                    {validation["Neck"] === "invalid" ?
                                        <div className='HeightAlert' style={{ color: "red", fontWeight: "500" }}> Input inválido o fuera de rango </div>
                                    : null }
                                </div>
                }
                                { PastSistolic ?
                                    null
                                :
                                <div className="UserProfileHeartAgeCalculatorWhiteBlockQuestion">
                                    <div className="HeartAgeCalculatorRightSideSurveyQ1Flex">
                                        <div className="UserWelcomeBlockYNQuestion UserWelcomeBlockYNQuestionFullSize" style={{color: validation["Sistolic"] === "invalid" ? "red" : validation["Sistolic"] === "valid" ? "#8BC53F" : null}}>Indícanos tu presión arterial sistólica&ensp;</div>
                                        <div className="UserWelcomeBlockPage1MoreInfo" onClick={() => toggleAdditional("PressureInfo")}>?</div>
                                    </div>
                                    <div className="UserWelcomeBlockPage1Specifics UserWelcomeBlockPage1SpecificsHidden" id="PressureInfo">Es la cifra superior (y más alta) en una medición de la presión arterial.</div>
                                    <div className="HeartAgeCalculatorRightSideSurveyQ1MeasureFlex">
                                    <input
                                        value={Sistolic}
                                        className="SignInInnerBoxInputTile"
                                        style={{ borderBottom: validation["Sistolic"] === "invalid" ? "red solid 1px" : validation["Sistolic"] === "valid" ? "#8BC53F solid 1px" : Sistolic.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Sistolic"] === "invalid" ? "#FFFAEA" : validation["Sistolic"] === "valid" || Sistolic.length === 0 ? "#FBFFFF" : "#F2F2FF" }}
                                        id="YMCSistolic"
                                        onChange={(e) => handleChange(e.target.value,setSistolic)}/>
                                    <div className="DiabetesRiskCalculatorRightSideSurveyQ4InputMeasure">mmHg</div>
                                    </div>
                                    {validation["Sistolic"] === "invalid" ?
                                        <div className='HeightAlert' style={{ color: "red", fontWeight: "500" }}> Input inválido o fuera de rango </div>
                                    : null }
                                </div>
                }
                            </div>
                        </div>
                    </div>
                    <div className='GeneralPurpleButtonFlex UserWelcomeBlockPageButton' onClick={() => HandleSubmitFirstPart()}>Comenzar<div className='triangle'><i className='innerarrowWhite'></i></div></div>
                    </>
                    : SurveyPage === 1 ?
                    <>
                    <div className='UserWelcomeBlockPageWideFlex'>
                        <div className='UserWelcomeBlockPageWideSideL'>
                            <div className='UserWelcomeBlockPage1TitleFlex'>
                                <div className='UserWelcomeBlockPage1Title'>Riesgo de Apnea del Sueño&ensp;</div>
                                <div className="UserWelcomeBlockPage1MoreInfo" onClick={() => toggleAdditional("Added1")}>?</div>
                            </div>
                            <div className="UserWelcomeBlockPage1Specifics UserWelcomeBlockPage1SpecificsHidden" id="Added1">Para vivir bien hay que dormir bien, roncar no es normal.
                            <br/>La apnea obstructiva del sueño es un trastorno en el que la respiración se interrumpe repetidamente durante el sueño, lo que puede afectar tu salud, energía diaria y calidad de vida. Si roncas, te despiertas cansado o sientes somnolencia durante el día, podrías estar en riesgo. Evaluar y gestionar este riesgo es clave para prevenir complicaciones y mejorar tu bienestar. Utiliza nuestra herramienta para identificar tu situación y tomar el control de tu salud.</div>
                            <img alt="" className='UserWelcomeBlockPage1TitleFoodImage' src="https://static.yomecontrolo.cl/public/img/calculator/SleepApneaSurveyImage.png" />
                            <div className='UserProfileInnerDivCalculatorWhiteBlockCompletionText'><span className='UserProfileInnerDivCalculatorWhiteBlockCompletionBigNumber'>2</span> de 2</div>
                            <div className='UserWelcomeIntroPageCounterLineStart'>
                                <div className='UserWelcomeIntroPageCounterLineBlue'></div>
                                <div className='UserWelcomeIntroPageCounterLinePurple'></div>
                            </div>
                        </div>
                        <div className='UserWelcomeBlockPageWideSideR'>
                            <div className='UserWelcomeBlockPage1Subtitle2'>Para cada ítem, piensa en los <span className='UserWelcomeBlockPage1Subtitle2Highlight'>últimos siete días</span> y responde 'Sí' o 'No' a las preguntas:</div>
                            {[...Object.keys(questionsYN).keys()].map((Question) => (
                            <div className='UserWelcomeBlockYNQuestionContainer' key={Object.keys(questionsYN)[Question]+Question} >
                                {console.log(YNAnswersCat[Question])}
                                <div className='UserWelcomeBlockYNQuestion' style={{color: YNAnswersCat[Question].length === 0 && YNIncomplete ? "red" : YNAnswersCat[Question].length !== 0 ? "#8BC53F" : null}}>{Question+1}- {questionsYN[Object.keys(questionsYN)[Question]].question}</div>
                                <div className='UserWelcomeBlockYNTileFlex'>
                                <div className={YNAnswersCat[Question] === "SI" ? "DiabetesRiskCalculatorRightSideSurveyQ1Tile DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile" : "DiabetesRiskCalculatorRightSideSurveyQ1Tile"} 
                                    id={Object.keys(questionsYN)[Question]+'Y'} 
                                    style={{borderBottom: YNAnswersCat[Question].length === 0 && YNIncomplete ? "red solid 1px" : YNAnswersCat[Question].length !== 0 ? "#8BC53F solid 1px" : "#BFD4E4 solid 1px", backgroundColor: YNAnswersCat[Question] === "SÍ" ? "#F2F2FF" : YNAnswersCat[Question].length === 0 && YNIncomplete === "invalid" ? "#FFFAEA" : "white"}}
                                    onClick={() => handleYNs(Question, Object.keys(questionsYN)[Question], 'Y')}>{questionsYN[Object.keys(questionsYN)[Question]].answers[0].text}</div>
                                <div className={YNAnswersCat[Question] === "NO" ? "DiabetesRiskCalculatorRightSideSurveyQ1Tile DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile" : "DiabetesRiskCalculatorRightSideSurveyQ1Tile"} 
                                    id={Object.keys(questionsYN)[Question]+'N'}
                                    style={{borderBottom: YNAnswersCat[Question].length === 0 && YNIncomplete ? "red solid 1px" : YNAnswersCat[Question].length !== 0 ? "#8BC53F solid 1px" : "#BFD4E4 solid 1px", backgroundColor: YNAnswersCat[Question] === "NO" ? "#F2F2FF" : YNAnswersCat[Question].length === 0 && YNIncomplete === "invalid" ? "#FFFAEA" : "white"}}
                                    onClick={() => handleYNs(Question, Object.keys(questionsYN)[Question], 'N')}>{questionsYN[Object.keys(questionsYN)[Question]].answers[1].text}</div>
                                </div>
                            </div>
                            ))}
                            <div className='UserWelcomeBlockYNQuestionAlert' id="YNVerif" style={{ color: "red", fontWeight: "500" }}>{YNIncomplete ? "Hay al menos una pregunta sin responder, por favor revise sus respuestas." : null}</div>
                        </div>
                    </div>
                    <div className='UserWelcomeBlockNextButtonFlex'>
                        <div className="GeneralWhiteButtonFlex UserWelcomeBlockPageButton1" onClick={() => {setSurveyPage(0); document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>
                            <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowPurple' style={{rotate:"180deg"}}></i></div>
                            <div className="GeneralWhiteButtonText GeneralWhiteButtonTextPreviousText">Anterior</div>
                        </div>
                        <div className="GeneralPurpleButtonFlex UserWelcomeBlockPageButton" onClick={() => YNVerify(true)} style={{marginInline:"auto"}}>
                            <div className="GeneralPurpleButtonText">Calcular</div>
                            <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowWhite'></i></div>
                        </div>
                    </div>
                    </>
                    : 
                    <>
                    <div className='UserWelcomeBlockPageWideFlex'>
                        <div className='UserWelcomeBlockPageWideSideL'>
                            <div className="UserProfileDiabetesWhiteBoxPart2">
                                <div className='HeartAgeCalculatorLeftSideResultHeartBlockInnerBlockFlex'>
                                    <div className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedLeft' style={{backgroundColor: Risk["risk"] === 0 ? "rgba(139, 197, 63, 0.47)" : Risk["risk"] === 1 ? "rgba(255, 205, 41, 0.50)" : "rgba(255, 79, 83, 0.47)", marginInline:"auto",width:"100%"}}>
                                        <img alt="" className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedLeftImage' src="https://static.yomecontrolo.cl/public/img/calculator/SleepApneaSurveyImage.png" />
                                    </div>
                                    <div className='HeartAgeCalculatorLeftSideResultHeartBlockInnerBlock' style={Risk["risk"] === 0 ? {backgroundColor:"#8BC53F"} : Risk["risk"] === 1 ? {backgroundColor:"#FFCD29"} : {backgroundColor:"#FF4F53", color:"white"}}>
                                        <div className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedUpTitle'>{Risk["points"]} / 8 Puntos</div>
                                        <h5 className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedTitle'>
                                            <span style={{fontWeight:"500"}}>Riesgo {Risk["risk_cat"]}</span>
                                        </h5>
                                        <div className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedUpTitle'>Síndrome de apnea obstructiva del sueño</div>
                                    </div>
                                </div>
                                {Risk["risk"] === 0 ?
                                <div className="UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedMeter2" style={{backgroundImage:"url('https://static.yomecontrolo.cl/public/img/calculator/RiskMeterHorizontalSimplified.png')",backgroundPosition: 'center',backgroundSize: 'contain',backgroundRepeat: 'no-repeat'}}>
                                    <img alt="" className="HeartAgeCalculatorLeftSideResultHeartBlockMeterFace" src="https://static.yomecontrolo.cl/public/img/calculator/RiskMeter_LowRiskFace.png" style={{left: "12px"}} />
                                </div>
                                : Risk["risk"] === 1 ?
                                <div className="UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedMeter2" style={{backgroundImage:"url('https://static.yomecontrolo.cl/public/img/calculator/RiskMeterHorizontalSimplified.png')",backgroundPosition: 'center',backgroundSize: 'contain',backgroundRepeat: 'no-repeat'}}>
                                    <img alt="" className="HeartAgeCalculatorLeftSideResultHeartBlockMeterFace" src="https://static.yomecontrolo.cl/public/img/calculator/RiskMeter_MidRiskFace.png" style={PagewidthCorrection === false ? {left: "36%", right: "64%"} : {left: "40%", right: "60%"}} />
                                </div>
                                :
                                <div className="UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedMeter2" style={{backgroundImage:"url('https://static.yomecontrolo.cl/public/img/calculator/RiskMeterHorizontalSimplified.png')",backgroundPosition: 'center',backgroundSize: 'contain',backgroundRepeat: 'no-repeat'}}>
                                    <img alt="" className="HeartAgeCalculatorLeftSideResultHeartBlockMeterFace" src="https://static.yomecontrolo.cl/public/img/calculator/RiskMeter_HighRiskFace.png" style={{right: "12px"}}/>
                                </div>
        }
                            </div>
                        </div>
                        <div className='UserWelcomeBlockPageWideSideR'>
                            <div className="UserProfileDiabetesWhiteBoxPart2">
                                <div className='UserWelcomeResultsCategories'>
                                    <div className="UserProfileInnerDivCalculatorExplanationBlockBigText" id="More1">La apnea obstructiva del sueño es un trastorno en el que la respiración se interrumpe repetidamente durante el sueño, lo que puede afectar tu salud, energía diaria y calidad de vida...
                                    <br/><div className='UserProfileInnerDivCalculatorExplanationBlockBigTextOption' onClick={() => toggleDescription("Less",1)}>Ver más</div></div>
                                    <div className="UserProfileInnerDivCalculatorExplanationBlockBigText HeartAgeCalculatorResultsRightSideWhatIfConsequenceHidden" id="Less1">La apnea obstructiva del sueño es un trastorno en el que la respiración se interrumpe repetidamente durante el sueño, lo que puede afectar tu salud, energía diaria y calidad de vida.<br/>
                                    Si roncas, te despiertas cansado o sientes somnolencia durante el día, podrías estar en riesgo. <br/>
                                    Evaluar y gestionar este riesgo es clave para prevenir complicaciones y mejorar tu bienestar. 
                                    <br/><div className='UserProfileInnerDivCalculatorExplanationBlockBigTextOption' onClick={() => toggleDescription("More",1)}>Ver menos</div></div>
                                    <h4 className='UserWelcomeBlockResultsCategoriesTitle' style={{marginBlock:"20px"}}>Para vivir mejor hay que dormir mejor, roncar no es normal.</h4>
                                    { Risk["risk"] === 0 ?
                                        <div className='UserWelcomeBlockResultsCategoriesTitle2'>Usted posee un riesgo BAJO de síndrome de apnea obstructiva del sueño, te recomendamos estar atento a los síntomas.</div>
                                    : Risk["risk"] === 1 ?
                                    <>
                                        <div className='UserWelcomeBlockResultsCategoriesTitle2'>Usted posee un Riesgo MEDIO de síndrome de apnea obstructiva del sueño, te recomendamos profundizar los estudios agendando un examen de poligrafía cardiorrespiratoria de sueño en tu centro de salud de preferencia.</div>
                                        <div className='GeneralPurpleButtonFlex UserWelcomeBlockPageButton' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/packs-de-examenes/detalles-de-pack?pack=PM00YMC043");}}>Generar Orden Médica</div>
                                    </>
                                    :
                                    <>
                                        <div className='UserWelcomeBlockResultsCategoriesTitle2'>Usted posee un Riesgo ALTO de síndrome de apnea obstructiva del sueño, te recomendamos profundizar los estudios agendando un examen de poligrafía cardiorrespiratoria de sueño en tu centro de salud de preferencia.</div>
                                        <div className='GeneralPurpleButtonFlex UserWelcomeBlockPageButton' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/packs-de-examenes/detalles-de-pack?pack=PM00YMC043");}}>Generar Orden Médica</div>
                                    </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                        
                    <div className='UserWelcomeBlockPageWideFlex'>
                      <div className='GeneralWhiteButtonFlex UserWelcomeBlockPageButton2' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/perfil-de-usuario/calculadora-de-salud");}}>Terminar</div>
                      <div className='GeneralPurpleButtonFlex UserWelcomeBlockPageButton' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/plan-de-intervencion");}}>Ir a Recomendaciones</div>
                    </div>
                    
                    </>
                    }
                    </>
                    : null}
                </div>
            </div>
        </div>
    );
};

export default SleepCalculator;